<template>
    <div class="Show">
        <van-nav-bar
                title="登录"
                left-text=""
        />
        <div class="cmain">
            <van-cell-group>
                <van-field
                        v-model="user.userName"
                        clearable
                        label="登录名"
                        placeholder="请输入手机号码或用户名"
                        :error-message="userError.userName"
                        @keydown="userError.userName=''"
                />

                <van-field
                        v-model="user.password"
                        type="password"
                        label="登录密码"
                        placeholder="请输入密码"
                        :error-message="userError.password"
                        @keydown="userError.password=''"
                />
            </van-cell-group>
            <div style="height: 30px"></div>
            <div class="login_btn_box">
                <van-button type="primary" size="large" v-if="!loading" @click="login()">登录</van-button>
                <van-button loading type="primary" disabled  size="large" loading-text="正在登录..." v-if="loading" />
                <!--<van-button type="default" size="large">忘记密码</van-button>-->
                <van-button type="default" size="large" @click="toRegist()">免费注册</van-button>
            </div>

            <!--<van-popup v-model="popupIsShow" position="bottom">
                <van-nav-bar title="忘记登录密码" left-text="" />
                
                <van-cell-group>
                    <van-field
                            v-model="username"
                            clearable
                            label="登录名"
                            right-icon="question-o"
                            placeholder="请输入手机号码或用户名"
                            :error-message="请输入正确的登录名"
                            label-align="left"
                            @click-right-icon="$toast('请输入账号和密码')"
                    />

                    <van-field
                            v-model="password"
                            type="password"
                            label="登录密码"
                            placeholder="请输入密码"
                            error-message=""
                    />
                </van-cell-group>
            </van-popup>-->
        </div>
    </div>
</template>

<script>
    import shopCart from '@/js/mixins/shopCart.js'
    import { setTimeout } from 'timers';
    export default {
        name: "Login",
        mixins: [shopCart],
        data() {
            return {
                loading: false,
                popupIsShow: true,
                user: {
                    userName: "",
                    password: ""
                },
                userError: {
                    userName: "",
                    password: ""
                }
            }
        },
        methods: {
            login() {
                var that = this;
                var shopId = this.$route.query.shopId
                var valid = window.consts.validate
                if(!this.user.userName) {
                    this.userError.userName = "请输入手号码或用户名!"
                    return false
                } else if (!this.user.password) {
                    this.userError.password = "请输入登录密码!"
                    return false
                }
                this.loading = true
                this.$axios.post(window.consts.apis.login, this.user).then(res => {
                    this.loading = false
                    if (res.success) {
                        localStorage.setItem(window.consts.strings.userToken, res.result.accessToken)
                        //登录成功获取信息
                        that.axios.get(window.consts.apis.getMyInfo).then(r=>{
                            if(r.success && r.result && r.result.id>0){
                                that.$store.dispatch('setUser', {
                                    id: r.result.id,
                                    uid: r.result.name,
                                    mobile: r.result.phoneNumber,
                                    email: '',
                                    lastLogin: ''
                                })
                            }
                        })
                        that.$store.dispatch('setUser', {
                            id: res.result.userId,
                            uid: '',
                            mobile: '',
                            email: '',
                            lastLogin: ''
                        })
                        that.getShopCartList(() => {
                            
                        });
                        // 绑定门店
                        if (shopId && shopId > 0) {
                            this.$axios.post(window.consts.apis.bindShop, { shopId: shopId }).then(sr => {
                                if (sr.success) {
                                    this.$toast.success({
                                        duration: 2000,
                                        forbidClick: true,
                                        loadingType: 'spinner',
                                        message: "门店绑定成功!",
                                        onClose: (rt => {
                                            this.skipToUrl()
                                        })
                                    });
                                } else {
                                    this.$toast.fail({
                                        duration: 2000,
                                        forbidClick: true,
                                        loadingType: 'spinner',
                                        message: "门店绑定失败，请重新绑定!",
                                        onClose: (rt => {
                                            this.skipToUrl()
                                        })
                                    });
                                }
                            })
                        } else {
                            // 跳转
                            this.skipToUrl()
                        }
                    } else {
                        this.$toast.fail("登录名或密码错误!")
                    }
                }, error => {
                    this.loading = false
                    this.$toast.fail("登录失败!")
                })
            },
            skipToUrl() {
                let that = this
                let q = that.$route.query
                if (q && q.returnUrl && (q.returnUrl.indexOf("/login") < 0 && q.returnUrl.indexOf("register") < 0)) {
                    that.$router.replace({ path: q.returnUrl })
                } else {
                    that.$router.replace('/m')
                }
            },
            toRegist() {
                var shopId = this.$route.query.shopId
                if (shopId && shopId > 0) {
                    this.$router.push({ path:'/m/register', query: { shopId: shopId } });
                } else {
                    this.$router.push({ path:'/m/register' });
                }
            },
            getShopCartList (callback) {
                this.$axios.get(window.consts.apis.getShoppingCartList, { params: { Page: 1, Size: 100} }).then(res => {
                    if (res.success) {
                        this.syncShopCart(res.result.items, callback);
                    } else {
                        callback();
                    }
                }).catch(e => {
                    callback();
                })
            }
        }
    }
</script>

<style scoped>
    .login_btn_box {
        width: 96%;
        margin:0 auto;
    }
    .van-cell-group {
        margin-top:25px;
    }
    .van-button {
        margin:5px auto;
    }
    .van-popup {
        height:100%;
    }
</style>